<template>
  <div class="faq-block">
    <faq-menu-block :id="id" :title="title" :children="children" />
  </div>
</template>

<script setup lang="ts">
import FaqMenuBlock from '@/components/FAQ/FaqMenuBlock.vue';
import type { IFaqMenuBlock } from '@/components/FAQ/types';

defineProps<IFaqMenuBlock>();
</script>
<style lang="scss" scoped>
.faq-block {
  padding: 24px 16px;
  gap: 16px;
  background: $Peak;

  @include media-min-sm {
    border-radius: 16px;
  }
}
</style>
